<template>
  <div>
    <app-header title="Template Log">
      <b-button variant="primary" class="mr-1" @click="download()">
        Download CSV (all)
      </b-button>
      <b-button variant="primary" @click="download(3)">
        Download CSV (3 days)
      </b-button>
    </app-header>
    <b-container class="mt-5">
      <b-table
        id="store-table"
        :per-page="perPage"
        :current-page="currentPage"
        :items="displayTemplates"
        :fields="fields"
        :busy="loading"
        show-empty
        striped
        hover
        responsive
      >
        <template v-slot:cell(updated)="data">
          {{ data.item.updated | moment("YYYY-MM-DD") }}
        </template>
        <template v-slot:cell(created)="data">
          {{ data.item.created | moment("YYYY-MM-DD") }}
        </template>
        <template v-slot:table-busy>
          <loading-spinner />
        </template>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="displayTemplates && displayTemplates.length"
        :per-page="perPage"
        align="right"
        aria-controls="subdistributor-table"
      />
    </b-container>
  </div>
</template>

<script>
import $api from '@/services/api';
import $csv from '@/services/csv';
import LoadingSpinner from '@/components/LoadingSpinner';
import AppHeader from '@/components/AppHeader';

export default {
  components: {
    AppHeader,
    LoadingSpinner,
  },

  data() {
    return {
      templates: null,
      sortOrder: null,
      fields: [
        { key: 'id', label: 'Template ID' },
        { key: 'manufacturer_name', label: 'Manufacturer Name' },
        { key: 'device_type', label: 'Device Type' },
        { key: 'device_name', label: 'Device Name' },
        { key: 'name', label: 'Template Name' },
        { key: 'hidden', label: 'Hidden', sortable: true },
        { key: 'updated', label: 'Updated', sortable: true },
        { key: 'created', label: 'Created', sortable: true },
        { key: 'hpgl_width', label: 'Width' },
        { key: 'hpgl_height', label: 'Height' },
      ],
      currentPage: 1,
      perPage: 10,
      loading: false,
    };
  },

  computed: {
    totalRows() {
      return this.templates && this.templates.length;
    },

    displayTemplates() {
      return this.templates && this.templates.slice(0).sort((a, b) => b.updated - a.updated).slice(0, 100);
    },
  },

  created() {
    this.refreshData();
  },

  methods: {
    refreshData() {
      this.loading = true;
      $api.get('/v1/internal/templates').then((templates) => {
        this.templates = templates;
        this.loading = false;
      }).catch(() => { this.loading = false; });
    },

    download(days) {
      let data = this.templates;
      if (days) {
        data = data.filter((item) => new Date(item.updated).getTime() > (Date.now() - days * 1000 * 60 * 60 * 24));
      }
      $csv.export(data, ['id', 'manufacturer_name', 'device_name', 'device_type', 'name', 'hidden', 'updated', 'created', 'hpgl_width', 'hpgl_height', 'svg'], 'templatelog.csv');
    },
  },
};
</script>
